<div class="row">
	<div class="col-2">
		<div class="menu-container">
			<ul nz-menu nzMode="vertical" nzTheme="light">
				<li *ngFor="let group of menu" nz-submenu [nzTitle]="group.label">
					<ul>
						<a *ngFor="let item of group.templates" nz-menu-item nzMatchRouter (click)="addColumn(item)">
							<span *ngIf="item.name.length > 0">
								<fa-icon [icon]="getMenuIcon(item)" size="xs"></fa-icon>
								{{item.name}}
							</span>
						</a>
						<li *ngFor="let subMenu of group.subMenus" nz-submenu [nzTitle]="subMenu.label">
							<ul>
								<a *ngFor="let item of subMenu.payload" nz-menu-item nzMatchRouter
									(click)="addColumn(item)">
									<span *ngIf="item.name.length > 0">
										<fa-icon [icon]="getMenuIcon(item)" size="xs"></fa-icon>
										{{item.name}}
									</span>
								</a>
							</ul>
						</li>
					</ul>
				</li>
			</ul>
		</div>
	</div>
	<div class="col">
		<form [formGroup]="form" nz-form>
			<nz-form-item>
				<nz-form-label [nzSpan]="6">Title</nz-form-label>
				<nz-form-control [nzSpan]="18">
					<input nz-input formControlName="title" placeholder="Enter title" />
				</nz-form-control>
			</nz-form-item>
			<nz-form-item>
				<nz-form-label [nzSpan]="6">Mode</nz-form-label>
				<nz-form-control [nzSpan]="18">
					<nz-select formControlName="mode" nzPlaceHolder="Select mode">
						<nz-option *ngFor="let item of options" [nzValue]="item.value" [nzLabel]="item.label">
						</nz-option>
					</nz-select>
				</nz-form-control>
			</nz-form-item>
			<nz-form-item>
				<nz-form-label [nzSpan]="6">Columns</nz-form-label>
				<nz-form-control [nzSpan]="18">
					<ul nz-list nzBordered nzSize="small">
						<li nz-list-item nzNoFlex *ngFor="let subColumn of subColumns.value; let i = index">
							<ul nz-list-item-actions>
								<nz-list-item-action>
								<button nz-button nzType="link" nzDanger (click)="removeItem(i)">Remove</button>
								</nz-list-item-action>
							</ul>
							<span *ngIf="subColumn.template?.group1">{{ subColumn.template?.group1 }} >> </span>
							<span *ngIf="subColumn.template?.group2">{{ subColumn.template?.group2 }} >> </span>
							{{ subColumn.template?.name }}
						</li>
					</ul>
				</nz-form-control>
			</nz-form-item>
			<nz-form-item>
				<nz-form-label [nzSpan]="6">Filter Operator</nz-form-label>
				<nz-form-control [nzSpan]="18">
					<nz-select formControlName="filterOperator" nzPlaceHolder="Select Filter">
						<nz-option [nzValue]="undefined" nzLabel="None"></nz-option>
						<nz-option [nzValue]="'Equals'" [nzLabel]="'Equals'"></nz-option>
						<nz-option [nzValue]="'NotEquals'" [nzLabel]="'Not Equals'"></nz-option>
						<nz-option [nzValue]="'GreaterThan'" [nzLabel]="'Greater Than'"></nz-option>
						<nz-option [nzValue]="'LessThan'" [nzLabel]="'Less Than'"></nz-option>
						<nz-option [nzValue]="'GreaterThanOrEqual'" [nzLabel]="'Greater Than Or Equal'"></nz-option>
						<nz-option [nzValue]="'LessThanOrEqual'" [nzLabel]="'Less Than Or Equal'"></nz-option>
					</nz-select>
				</nz-form-control>
			</nz-form-item>
			<nz-form-item>
				<nz-form-label [nzSpan]="6">Filter Value</nz-form-label>
				<nz-form-control [nzSpan]="18">
					<input nz-input formControlName="filterValue" placeholder="Filter Value" />
				</nz-form-control>
			</nz-form-item>
			<button nz-button (click)="handleCancel()">Cancel</button>
			<button nz-button class="ms-2" nzType="primary" [disabled]="form.invalid" (click)="handleSave()">Save</button>
			<button nz-button class="float-end" nzType="default" [nzDanger] (click)="handleDelete()">Delete</button>
		</form>
	</div>
</div>
